import React, { useState, useEffect } from "react";
import {
  makeStyles,
  Typography,
  Paper,
  Grid,
  Backdrop,
  Chip,
  lighten,
  Button,
  ButtonGroup,
  useTheme,
  CircularProgress,
  Badge,
  Avatar,
  MenuItem,
  Select,
  FormControl,
  InputLabel
} from "@material-ui/core";
import clsx from "clsx";

import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";

import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableHead from "@material-ui/core/TableHead";

import { useDispatch, useSelector } from "react-redux";
import { TablePaginationActions } from "../../utils/TablePaginationAction";
import Search from "../../utils/Search";
import { getUsers } from "../../actions/usersAction";
import CreateUserModal from "../Modals/User/CreateUserModal";
import Feedback from "../../utils/Feedback";
import EditUserModal from "../Modals/User/EditUserModal";
import DeleteUserModal from "../Modals/User/DeleteUserModal";
import { getLocations, getUsersByLocation } from "../../actions/usersAction";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),

    // width: "100%",
    overflow: "hidden",
  },
  title: {
    color: lighten(theme.palette.common.black, 0.75),
    display: "block",
    fontSize: 15,
    fontWeight: 900,
  },
  textField: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(3),
  },

  action: {
    marginBottom: 30,
  },
  btn: {
    marginTop: 30,
    marginBottom: 30,
  },
  btn2: {
    marginBottom: 30,
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  table: {
    minWidth: 350,
  },
  chip: {
    paddingLeft: 8,
    paddingRight: 8,
    fontSize: "0.8rem"
  },
  statusDarkGreen: {
    borderColor: "#4caf50",
  },
  statusGreen: {
    borderColor: "#1de9b6",
  },
  statusYellow: {
    borderColor: "#fbc02d",
  },
  statusOrange: {
    borderColor: "#ff9800",
  },
  statusRed: {
    borderColor: "#ef5350",
  },
  marginBottom: {
    marginBottom: 30,
  },
  divider2: {
    height: 28,
    margin: 4,
  },
  info: {
    padding: theme.spacing(4),
    marginBottom: 30,
  },
  typo: {
    lineHeight: 1,
    fontWeight: 900,
  },
  formcontrol: {
    textAlign: "left",
    marginTop: theme.spacing(-3),
    marginLeft: theme.spacing(60),
    minWidth: 300,
    [theme.breakpoints.down("sm")]: {
        minWidth:300,
        marginLeft:0
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: "100%",
      marginLeft:0
    },
  },
  // avatar: {
  //   margin: "auto",
  //   width: theme.spacing(7),
  //   height: theme.spacing(7),
  //   marginBottom: 30,
  // },
  link: {
    color: theme.palette.type === "light" ? "#333" : "#fff",
  },
  card2: {
    padding: theme.spacing(5),
    marginTop: 20,
    marginBottom: 20,
    width: 300,
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: theme.spacing(3),
    }

  },

  avatar: {
    width: 100,
    height: 100,
    margin: "auto",
    marginBottom: 20,
    opacity: 0.9,
    display: "flex",
    backfaceVisibility: "hidden",
    // [theme.breakpoints.down("sm")]: {
    //   width: "100%",

    // }
  },
}));

const INIT_STATE = {
  location: "",
};

const Users = () => {
  const classes = useStyles();
  const theme = useTheme();

  const dispatch = useDispatch();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [search, setSearch] = useState("");
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [state, setState] = useState(INIT_STATE);

  const [getId, setGetId] = useState("");

  const [feed, setFeed] = React.useState({
    loading: false,
    open: false,
    message: "",
    success: false,
  });

  const { profile, loading, error, users,locations } = useSelector((state) => state.users);
                      
  useEffect(() => {
    dispatch(getUsers());
    dispatch(getLocations())
  }, [dispatch]);

  useEffect(() => {
    let location = state.location
    if (location === null || location === ""){
      dispatch(getUsers());
    }
    else{
      dispatch(getUsersByLocation(location));
    }
      
  }, [dispatch, state.location]);

  useEffect(() => {
    const abortController = new AbortController();
    if (error && error !== null) {
      setFeed((prev) => ({
        loading: false,
        open: true,
        message: error,
        success: false,
      }));
    }
    return () => {
      abortController.abort();
    };
  }, [error]);

  const updateSearch = (e) => {
    setSearch(e.target.value.substr(0, 20));
  };

  const ResetSearch = (e) => {
    e.preventDefault();
    setSearch("");
  };

  const handleOpenCreate = () => {
    setOpenCreate(true);
  };

  const handleCloseCreate = () => {
    setOpenCreate(false);
  };

  const handleOpenEdit = (id) => {
    setGetId(id);
    setOpenEdit(true);
  };

  const handleCloseEdit = () => {
    setOpenEdit(false);
  };

  const handleOpenDelete = (id) => {
    setGetId(id);
    setOpenDelete(true);
  };

  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  
  const handleChange = (e) => {
    e.persist();
    setState((prevState) => ({ ...prevState, [e.target.name]: e.target.value }));
    
  };

  let filteredRows = () =>
    users === undefined
      ? []
      : users.filter((row) => {
          if (search !== "") {
            return (
              row.firstname.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
              row.lastname.toLowerCase().indexOf(search.toLowerCase()) !== -1 ||
              row.email.toLowerCase().indexOf(search.toLowerCase()) !==
                -1 ||
              row.title.toLowerCase().indexOf(search.toLowerCase()) !== -1
            );
          } else {
            return row;
          }
        });

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 20));
    setPage(0);
  };

  const handleCloseFeed = () => {
    setFeed((prevState) => ({ ...prevState, open: false }));
  };

  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, Array(50) - page * rowsPerPage);

    let isAdmin = profile
    ? (profile &&
      profile.role && profile.role.map((role) => role.name).includes("admin"))
     : false;

  return (
    <div className={classes.root}>
      <CreateUserModal {...{ openCreate, handleCloseCreate }} />
      <EditUserModal {...{ openEdit, handleCloseEdit, id: getId }} />
      <DeleteUserModal {...{ openDelete, handleCloseDelete, id: getId }} />

      {feed.success === false && (
        <Feedback
          handleCloseFeed={handleCloseFeed}
          open={feed.open}
          severity="error"
          message={feed.message}
        />
      )}
      <Typography className={classes.title} variant="overline">
        Users
      </Typography>
      <Grid container alignItems="center" spacing={3}>
        <Grid item>
          {isAdmin && (
            <Button
              color="primary"
              variant="contained"
              onClick={handleOpenCreate}
              className={classes.btn2}
            >
              Create
            </Button>
          )}
        </Grid>
        <Grid item>
          <Search
            updateSearch={updateSearch}
            placeholder="Search..."
            search={search}
            ResetSearch={ResetSearch}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormControl variant="outlined" className={classes.formcontrol}>
            <InputLabel id="location">
              Filter By Location
            </InputLabel>
            <Select
              labelId="location"
              id="location"
              fullWidth
              name="location"
              value={state.location || ""}
              onChange={handleChange}
              label="Filter By Location"
            >
              <MenuItem value={null}>
                <em>All</em>
              </MenuItem>
              {locations &&
                locations.map((location) => (
                  <MenuItem key={location._id} value={location._id}>
                    {location.displayname}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
     
      <Paper>
        <TableContainer>
          <Table className={classes.table} aria-label="custom pagination table">
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>Firstname</TableCell>
                <TableCell>Lastname</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Primary Location</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Last Active</TableCell>
                {isAdmin && <TableCell>Actions</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? filteredRows().slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : filteredRows()
              ).map((row, i) => {
                return (
                  <TableRow hover key={row._id}>
            
                    <TableCell component="th" scope="row">
                      <Avatar
                        alt={row.photo}
                        src={row.photo}
                      />
                    </TableCell>

                    <TableCell component="th" scope="row">
                        {row.firstname}  
                    </TableCell>

                    <TableCell component="th" scope="row">
                      {row.lastname}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.email}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.title}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.location && row.location.displayname}
                    </TableCell>
                    <TableCell component="th" scope="row">
                    <Chip
                          label={row.active? "Active" : "Inactive"}
                          variant="outlined"
                          className={row.active ? clsx(classes.chip, classes.statusDarkGreen)
                          : clsx(classes.chip, classes.statusRed)} 
                        />
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.lastActive?.split("T")[0] || "Never Connected"}
                    </TableCell> 
                    {isAdmin && (
                      <TableCell>
                        <ButtonGroup variant="contained">
                          <Button
                            color="primary"
                            onClick={() => handleOpenEdit(row._id)}
                          >
                            <EditIcon />
                          </Button>
                          <Button
                            color="secondary"
                            onClick={() => handleOpenDelete(row._id)}
                          >
                            <DeleteIcon />
                          </Button>
                        </ButtonGroup>
                      </TableCell>
                    )}
                  </TableRow>
                );
              })}

              {emptyRows > 0 && (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6} />
                </TableRow>
              )}
              {filteredRows().length === 0 && (
                <TableRow hover>
                  <TableCell
                    colSpan={10}
                    align="center"
                    style={{
                      fontWeight: 900,
                      color: "#616161",
                      textAlign: "center",
                    }}
                    component="th"
                    scope="row"
                  >
                    No Records To Display
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          component="div"
          rowsPerPageOptions={[10, 25, 50, { label: "All", value: -1 }]}
          colSpan={3}
          count={filteredRows().length}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: { "aria-label": "rows per page" },
            native: true,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
        />
      </Paper>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default Users;
